import React from 'react';
import Step1CategorySelection from '../SubmissionForm/Step1CategorySelection';
import Step3Success from '../SubmissionForm/Step3Success';
import ErrorDisplay from '../SubmissionForm/ErrorDisplay';
import QualificationForm from '../QualificationForm';

const QualificationSubmissionForm = ({
  selectedCategory,
  submitted,
  error,
  isSubmitting,
  categories,
  handleCategoryChange,
  handleFormSubmit,
  dynamicFormSchema,
  userRoleType,
  userPillar,
  initialValues,
  isEditMode,
}) => {
  return (
    <div className="space-y-8">
      {/* Step 1: Category Selection - Only show when no category selected */}
      {!selectedCategory && (
        <Step1CategorySelection
          selectedCategory={selectedCategory}
          categories={categories}
          handleCategoryChange={handleCategoryChange}
        />
      )}

      {/* Step 2: Form Details - Only show when category is selected and not submitted */}
      {selectedCategory && !submitted && (
        <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
          <div className="flex items-center mb-6">
            <div className="w-8 h-8 bg-red-smdd rounded-full flex items-center justify-center mr-4">
              <span className="text-white text-sm font-bold">2</span>
            </div>
            <div>
              <h2 className="text-2xl font-baijamjuree font-extrabold text-black">
                Qualification Details
              </h2>
              <p className="text-gray-700 mt-1">
                Complete your {selectedCategory} qualification
              </p>
            </div>
          </div>

          {dynamicFormSchema && (
            <div className="ml-12 mr-12">
              <QualificationForm
                schema={dynamicFormSchema}
                onSubmit={handleFormSubmit}
                isSubmitting={isSubmitting}
                category={selectedCategory}
                userRoleType={userRoleType}
                userPillar={userPillar}
                initialValues={initialValues}
                isEditMode={isEditMode}
              />
            </div>
          )}
        </div>
      )}

      {/* Step 3: Success Message - Only show when submitted */}
      {submitted && <Step3Success selectedCategory={selectedCategory} />}

      {/* Error Display */}
      <ErrorDisplay error={error} />
    </div>
  );
};

export default QualificationSubmissionForm;
